import {
  MenuConfig,
  MetricConfig,
  MenuType,
  LeaderboardMetric,
} from "@/types/leader-board";

export const MENU_CONFIG: Record<MenuType, MenuConfig> = {
  users: {
    backgroundImage: "/assets/leaderboard/leaderboard_users_bg.gif",
    defaultAvatar: "/assets/avatar.png",
    displayName: "Users",
  },
  collections: {
    backgroundImage: "/assets/leaderboard/leaderboard_collection_bg.gif",
    defaultAvatar: "/assets/avatar.png",
    displayName: "Collections",
  },
  nft: {
    backgroundImage: "/assets/leaderboard/leaderboard_nft_bg.gif",
    defaultAvatar: "/assets/avatar.png",
    displayName: "NFTs",
  },
} as const;

export const METRIC_CONFIG: Record<
  LeaderboardMetric,
  MetricConfig & { icon?: any; color?: string }
> = {
  all_stars: {
    colorClass: "text-primary-yellow",
    color: "text-primary-yellow",
    suffix: "",
    showIcon: true,
    icon: null,
  },
  volume: {
    colorClass: "text-primary-blue",
    color: "text-primary-blue",
    suffix: "TON",
    showIcon: false,
    icon: null,
  },
  level: {
    colorClass: "text-primary-purple",
    color: "text-primary-purple",
    suffix: "LVL",
    showIcon: false,
    icon: null,
  },
} as const;

export const TOP_POSITION_COLORS = {
  1: "#FFD900",
  2: "#C2C2C2",
  3: "#E6591D",
} as const;

export const ROUTE_PATHS = {
  users: (address: string) => `/owner/${address}`,
  collections: (address: string) => `/collection/${address}`,
  nft: (address: string) => `/nft/${address}`,
} as const;

export const METRIC_TO_PARAM_MAP = {
  volume: "volume" as const,
  level: "experience" as const,
  all_stars: "stars" as const,
} as const;

export const LEADERBOARD_CONSTANTS = {
  DEFAULT_LIMIT: 10,
  TON_DIVISOR: 1e9,
  ADDRESS_PREFIX_LENGTH: 8,
  MIN_ITEMS_FOR_TOP_POSITIONS: 3,
  DEFAULT_AVATAR_SIZE: 24,
  LARGE_AVATAR_SIZE: 34,
  DEFAULT_AVATAR: "/assets/owner-avatar.gif",
} as const;

export const LEADERBOARD_TEXT = {
  UNKNOWN_NAME: "Unknown",
  NO_DATA_AVAILABLE: "No data available",
  LOADING: "Loading...",
  PLACE_SUFFIX: "PLACE",
  LEADERBOARD_TITLE: "LEADERBOARD",
} as const;
